import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Save, Printer, FilePlus, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Header } from './Header';
import { DISPLAY } from './landing/shared';

export function ToolLayout({ title, subtitle, icon: Icon, onSave, onPrint, onNew, saving, children, rightExtra }) {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate('/')} className="w-9 h-9 rounded-full border border-white/10 text-slate-400 hover:text-white hover:bg-white/5 flex items-center justify-center transition-colors" data-testid="tool-back-btn"><ArrowLeft className="w-4 h-4" /></button>
            <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-cyan-500 to-emerald-500 flex items-center justify-center shadow-lg shadow-cyan-500/20">{Icon && <Icon className="w-5 h-5 text-slate-950" />}</div>
            <div><h1 className="text-xl font-semibold text-slate-100 tracking-tight" style={{ fontFamily: DISPLAY }}>{title}</h1>{subtitle && <p className="text-sm text-slate-400">{subtitle}</p>}</div>
          </div>
          <div className="flex gap-2">
            {rightExtra}
            {onNew && <Button variant="outline" size="sm" onClick={onNew} className="rounded-full border-white/10 bg-transparent text-slate-200 hover:bg-white/5"><FilePlus className="w-4 h-4 mr-1" /> New</Button>}
            {onPrint && <Button variant="outline" size="sm" onClick={onPrint} className="rounded-full border-white/10 bg-transparent text-slate-200 hover:bg-white/5"><Printer className="w-4 h-4 mr-1" /> Print</Button>}
            {onSave && <Button size="sm" onClick={onSave} disabled={saving} className="rounded-full bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-400 hover:to-emerald-400 text-slate-950 font-semibold">{saving ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />} Save</Button>}
          </div>
        </div>
        {children}
      </div>
    </>
  );
}
